import React from "react";
import "../card/card.scss";
import { Dialog } from "@mui/material";
import Button from "../button/Button";
import { CloseIcon } from "../../icons/svg";
import tickIcon from "../../images/tickIcon.png";

const SaveAsDraft = ({ open, handleClose, showSubmit, setShowSubmit }) => {
  const handleSubmitShow = () => {
    setShowSubmit(false);
  };

  return (
    <div className={`SaveAsDraft ${!showSubmit ? "submitWidth" : ""}`}>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className={`SaveAsDraft ${!showSubmit ? "submitWidth" : ""}`}
      >
        {showSubmit ? (
          <>
            <div className="modalHeader">
              <h3 className="h3">Save Order as draft?</h3>
              <button onClick={handleClose}>
                <CloseIcon />
              </button>
            </div>
            <div className="modalContent">
              <p>
                Are you sure that you want cancel the order from process? If you
                want to save all the information as draft then click the button
                “Save as Draft” From below
              </p>
              <Button
                text="Save as Draft"
                type="button"
                onClick={handleSubmitShow}
              />
            </div>
          </>
        ) : (
          <>
            <div className="submitModal">
              <div className="modalHeader">
                <button onClick={handleClose}>
                  <CloseIcon />
                </button>
              </div>
              <div className="modalContent">
                <img
                  src={tickIcon}
                  width="71px"
                  height="66px"
                  alt="tick-icon"
                />
                <h3 className="h3">Successfully Saved</h3>
                <p>
                  You order form has been saved as draft successfully! You
                  submitted information is saved. You can view the draft anytime.
                </p>
              </div>
            </div>
          </>
        )}
      </Dialog>
    </div>
  );
};

export default SaveAsDraft;
